module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ab489520d630473859477c4c30196481.png";